import React, { useCallback, useEffect, useState } from "react";
import AdminSidebar from "./Components/MenuSidebar";
import AdminHeader from "./../Admin/Components/AdminHeader";
import { useDispatch, useSelector } from "react-redux";
import { PaginationType } from "../../Constants/Interfaces";
import { Button, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faDotCircle,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import {
  getNotificationsAction,
  markReadNotificationAction,
} from "../../Services/Store/Actions/MessageConversationsAction";
import { showToast } from "../../utils/helpers";
import RightSlidingPanel from "../Admin/Components/RightSlidingPanel";
import PanelWrapper from "./PanelWrapper";
import ConfirmationModal from "../../Components/ConfirmationModal";
import ActionMenu from "../../Components/ActionMenu";
import { useLocation } from "react-router";
import Pagination from "../../Components/Pagination";

const NotificationList = () => {
  const dispatch = useDispatch();
  const { notifications } = useSelector((state: any) => state.messages);
  // Shared by /user/notifications and /admin/notifications — pick by route.
  const { pathname } = useLocation();
  const panelType: "admin" | "user" = pathname.startsWith("/admin")
    ? "admin"
    : "user";

  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [readLoading, setReadLoading] = useState({});
  const [conversationList, setConversationList] = useState([]);
  const [pagination, setPagination] = useState<PaginationType | null>(null);

  const [readNotification, setReadNotification] = useState({
    show: false,
    item: null,
  });

  const getNotifications = useCallback(
    (page: number = 1) => {
      console.log("Featching");

      if (!fetching) {
        setFetching(true);

        const param = {
          page,
          limit: 20,
        };

        getNotificationsAction(param, dispatch)
          .then((res) => {
            console.log("RES: ", res);

            if (res.type === "success") {
              setPagination(res.pagination);
            }
          })
          .catch((err) => {
            showToast("error", err.message);
          })
          .finally(() => setFetching(false));
      }
    },
    [pagination]
  );

  const markerReadNotification = (item: object) => {
    const notId = item?.id;
    if (!readLoading[notId] && item.isRead === false) {
      setReadLoading({
        [notId]: true,
      });

      markReadNotificationAction({ id: notId }, dispatch)
        .then((res) => {})
        .catch((err) => {})
        .finally(() =>
          setReadLoading({
            [notId]: false,
          })
        );
    }
  };

  useEffect(() => {
    setConversationList(notifications);
  }, [notifications]);

  useEffect(() => {
    getNotifications();
  }, []);

  return (
    <PanelWrapper type={panelType}>
      <div className="container">
        <div className="page-header">
          <h2>Notifications</h2>
        </div>

        <div className="page-content-card">
          <div className="listing-tables">
            <Table responsive>
              <thead>
                <tr>
                  <th>Title</th>
                  <th className="text-center" style={{ width: 100 }}>
                    Status
                  </th>
                  <th className="action-col">Action</th>
                </tr>
              </thead>

              <tbody>
                {!fetching && conversationList.length === 0 && (
                  <tr>
                    <td colSpan={3} align="center">
                      No Notifications available
                    </td>
                  </tr>
                )}

                {conversationList.length > 0 &&
                  conversationList.map((item, index) => {
                    return (
                      <tr>
                        <td>{item.title}</td>
                        <td className="text-center">
                          {item?.isRead && (
                            <span
                              className="status-icons text-secondary"
                              title="Success"
                            >
                              <FontAwesomeIcon icon={faDotCircle} />
                            </span>
                          )}
                          {!item?.isRead && (
                            <span
                              className="status-icons text-success"
                              title="Success"
                            >
                              <FontAwesomeIcon icon={faDotCircle} />
                            </span>
                          )}
                        </td>
                        <td className="action-col">
                          <div className="d-flex align-items-center justify-content-center">
                            <ActionMenu
                              items={[
                                {
                                  label: "Details",
                                  icon: faChevronRight,
                                  loading: readLoading[item.id],
                                  onClick: () => {
                                    markerReadNotification(item);
                                    setReadNotification({ show: true, item });
                                  },
                                },
                              ]}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })}

                {fetching && (
                  <tr>
                    <td colSpan={3} align="center">
                      <FontAwesomeIcon icon={faSpinner} spin />
                    </td>
                  </tr>
                )}
              </tbody>

              <tfoot>
                <tr>
                  <td colSpan={5}>
                    <Pagination
                      pagination={pagination}
                      onPageChange={(page) => getNotifications(page)}
                    />
                  </td>
                </tr>
              </tfoot>
            </Table>
          </div>
        </div>
      </div>

      {readNotification.show && (
        <ConfirmationModal
          heading={readNotification?.item?.title}
          message={readNotification?.item?.body}
          show={readNotification.show}
          closeModal={() => setReadNotification({ show: false, item: null })}
          buttons={[
            {
              text: "Close",
              action: () => setReadNotification({ show: false, item: null }),
            },
          ]}
        />
      )}
    </PanelWrapper>
  );
};

export default NotificationList;
